import { render } from "./DropdownHeader.vue?vue&type=template&id=5cd9d4bd"
import script from "./DropdownHeader.vue?vue&type=script&lang=js"
export * from "./DropdownHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__